import React, { Component } from 'react';
import {Router, Route, Switch, Link} from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css';
import history from './history';

// Include your new Components here
import Search from './component/search/search.jsx';
import Navbar from './component/navbar/navbar.jsx'
import House from './component/house/house.jsx'
import Signin from './component/user/signin';
import UserProfile from "./component/user/UserProfile";
import Detail from './component/detail/detail.jsx';
import PostHouse from './component/user/post';

class App extends Component {
  render() {
    return (
      <div>
        <Router history={history} basename={process.env.PUBLIC_URL}>
          <Navbar />
          <Switch>
            <Route exact path="/" component={Search}/>
            <Route exact path="/house" component={House}/>
            <Route exact path="/detail/:id" component={Detail}/>
            <Route path="/signin" component={Signin} />
            <Route path="/users/profile" component={UserProfile} />
            {/*
              Add routes for new pages here!
              Here's an example. To view this route, just go to http://localhost:3000/example
              */}
          </Switch>
        </Router>
        {/* <PostHouse/>*/}
      </div>
    );
  }
}

export default App;
